'use client';

import { useEffect } from 'react';
import * as Fathom from 'fathom-client';

const FATHOM_SITE_ID = 'NRELDNWV';

export default function FathomAnalytics() {
  useEffect(() => {
    Fathom.load(FATHOM_SITE_ID, {
      auto: false,
    });
  }, []);

  return null;
}
